var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, property } from 'lit-element';
import { AppContextType } from '@embed/components/helpers';
import { uuidv4 } from '@embed/helpers';
import fwnInit from '@src/embeds/utils/fwnInit';
import { WidgetTypesEnum } from '../embed/widgetTypes';
fwnInit(window);
class StorylinkElement extends LitElement {
    constructor() {
        super(...arguments);
        this.channel = '';
        this.playlist = '';
        this.video = '';
        this.hashtag = '';
        this.__version = process.env.RELEASE_VERSION;
        // TODO polyfills?
        this.widget_id = uuidv4();
        this.onClick = () => {
            var _a, _b;
            (_b = (_a = window._fwn) === null || _a === void 0 ? void 0 : _a.play) === null || _b === void 0 ? void 0 : _b.call(_a, Object.assign({ type: WidgetTypesEnum.STORYLINK, widget_id: this.widget_id, app_context_type: AppContextType.EMBED_STORYLINK_CONTEXT_TYPE }, this.attrs), { muted: false });
        };
    }
    get attrs() {
        return Object.fromEntries(Array.from(this.attributes)
            .filter((attr) => !['class', 'style'].includes(attr.name))
            .map((attr) => [attr.name, attr.value]));
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        this.addEventListener('click', this.onClick);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!this.getAttribute('class') && !this.getAttribute('style')) {
            const className = `fw-${Math.round(Math.random() * 10000)}`;
            const styleTag = document.createElement('style');
            styleTag.innerHTML = `
      fw-storylink.${className} {
        cursor: pointer;
        font-weight: bold;
        position: relative;
      }
      fw-storylink.${className}:before {
        bottom: 0;
        content: '';
        left: 0;
        opacity: 0.25;
        position: absolute;
        width: 100%;

        border: 1px solid gray;
      }

      fw-storylink.${className}:after {
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        width: 0%;

        border: 1px solid;
        border-width: 1px;
        border-image-slice: 1;
        border-image-source: var(--gradient);

        transition: 0.25s;
      }

      fw-storylink.${className}:hover:after {
        width: 100%;
      }
    `;
            this.appendChild(styleTag);
            this.classList.add(className);
        }
    }
}
__decorate([
    property({ type: String })
], StorylinkElement.prototype, "channel", void 0);
__decorate([
    property({ type: String })
], StorylinkElement.prototype, "playlist", void 0);
__decorate([
    property({ type: String })
], StorylinkElement.prototype, "video", void 0);
__decorate([
    property({ type: String })
], StorylinkElement.prototype, "hashtag", void 0);
if (!customElements.get('fw-storylink')) {
    customElements.define('fw-storylink', StorylinkElement);
}
